import Vue from 'vue'
import Router from 'vue-router'

//组件模块
import Login from '../view/Login'
import client_download from '../view/client_download.vue'
import infoBinding from '../view/infoBinding'
import YZcode from '../view/y_z_code'
import Home from '../view/index/Home'
import TeacherCurriculumList from '../view/index/TeacherCurriculumList'
import Findpwd from '../view/Findpwd'

import Opencourses from '../view/index/Courses/Opencourses'
import Opencourses_tow from '../view/index/Courses/Opencourses_tow'
import video_info from '../view/index/Courses/video_info'

// import Knowledge from '../view/index/Courses/Knowledge'
import coursemap from '../view/index/Courses/coursemap'
import CoursePlay from '../view/index/Courses/Courseplay'
import video_file from '../view/index/Courses/video_file'
import Customizedcourses from '../view/index/Courses/Customizedcourses'
import Question from '../view/index/Question/Question'

import File from '../view/index/File/File'
import Filetow from '../view/index/File/File-tow.vue'
import file_video from '../view/index/File/file_video'
import FileQCregister from '../view/index/File/FileQCregister'
import FileQCregisterfile from '../view/index/File/FileQCregisterfile'
import Livebroadcast from '../view/index/Live/Livebroadcast'
import Liveqa from '../view/index/Live/Liveqa'
import Liveintroduce from '../view/index/Live/Liveintroduce'
import Livebroadcasting from '../view/index/Live/Livebroadcasting'
import Minenode from '../view/index/Mine/Node/Minenode'
import Minenodedetail from '../view/index/Mine/Node/Minenodedetail'
import Personal from '../view/index/Mine/PersonalCenter/PersonalCenter'
import Collect from '../view/index/Mine/Collect/Collect'
// import Help from '../view/index/Mine/Help/Help'
import Watch from '../view/index/Mine/Watch/Watch.vue'

import statute from '../view/index/Statute/statute.vue'
import statute_map from '../view/index/Statute/statute_map.vue'
import statute_content from '../view/index/Statute/statute_content.vue'
import Official_account_list from '../view/index/Statute/Official_account_list'

import Taskvideo from '../view/index/Task/Taskvideo'
import Taskfile from '../view/index/Task/Taskfile'
import pdf from '../view/index/Task/taskfile/Pdf.vue'
import video from '../view/index/Task/taskfile/Video.vue'
import Tasklist from '../view/index/Task/Tasklist'
import Tasksubject from '../view/index/Task/Tasksubject'
import TasksubjeCtresult from '../view/index/Task/TasksubjeCtresult'
import Taskreview from '../view/index/Task/Taskreview'
import TaskQuestionnaire from '../view/index/Task/TaskQuestionnaire'

import evaluationlist from '../view/index/evaluation/list.vue'
import evalsubject from '../view/index/evaluation/subject.vue'
import evalsubjeCtresult from '../view/index/evaluation/subjeCtresult.vue'

import consult from '../view/index/Mine/consult/consult'
import moderator from '../view/index/Moderator/moderator.vue'

//游客
import visitor_Home from '../view/visitor/Home'
import visitor_TeacherCurriculumList from '../view/visitor/TeacherCurriculumList.vue'
import visitor_Opencourses from '../view/visitor/Courses/Opencourses.vue'
import visitor_Opencourses_tow from '../view/visitor/Courses/Opencourses_tow.vue'
import visitor_coursemap from '../view/visitor/Courses/coursemap.vue'
import visitor_CoursePlay from '../view/visitor/Courses/Courseplay.vue'
import visitor_video_file from '../view/visitor/Courses/video_file.vue'
import visitor_Customizedcourses from '../view/visitor/Courses/Customizedcourses.vue'
import visitor_Question from '../view/visitor/Question/Question.vue'

import visitor_File from '../view/visitor/File/File.vue'
import visitor_Filetow from '../view/visitor/File/File-tow.vue'
import visitor_file_video from '../view/visitor/File/file_video.vue'
import visitor_FileQCregister from '../view/visitor/File/FileQCregister.vue'
import visitor_FileQCregisterfile from '../view/visitor/File/FileQCregisterfile.vue'
import visitor_Livebroadcast from '../view/visitor/Live/Livebroadcast.vue'
import visitor_Liveqa from '../view/visitor/Live/Liveqa.vue'
import visitor_Liveintroduce from '../view/visitor/Live/Liveintroduce.vue'
import visitor_Livebroadcasting from '../view/visitor/Live/Livebroadcasting.vue'
import visitor_Minenode from '../view/visitor/Mine/Node/Minenode.vue'
import visitor_Minenodedetail from '../view/visitor/Mine/Node/Minenodedetail.vue'
import visitor_Personal from '../view/visitor/Mine/PersonalCenter/PersonalCenter.vue'
import visitor_Collect from '../view/visitor/Mine/Collect/Collect.vue'
// import Help from '../view/index/Mine/Help/Help'
import visitor_Watch from '../view/visitor/Mine/Watch/Watch.vue'

import visitor_statute from '../view/visitor/Statute/statute.vue'
import visitor_statute_map from '../view/visitor/Statute/statute_map.vue'
import visitor_statute_content from '../view/visitor/Statute/statute_content.vue'
import visitor_Official_account_list from '../view/visitor/Statute/Official_account_list.vue'

import visitor_Taskvideo from '../view/visitor/Task/Taskvideo.vue'
import visitor_Taskfile from '../view/visitor/Task/Taskfile.vue'
import visitor_pdf from '../view/visitor/Task/taskfile/Pdf.vue'
import visitor_video from '../view/visitor/Task/taskfile/Video.vue'
import visitor_Tasklist from '../view/visitor/Task/Tasklist.vue'
import visitor_Tasksubject from '../view/visitor/Task/Tasksubject.vue'
import visitor_TasksubjeCtresult from '../view/visitor/Task/TasksubjeCtresult.vue'
import visitor_Taskreview from '../view/visitor/Task/Taskreview.vue'
import visitor_TaskQuestionnaire from '../view/visitor/Task/TaskQuestionnaire.vue'

import visitor_evaluationlist from '../view/visitor/evaluation/list.vue'
import visitor_evalsubject from '../view/visitor/evaluation/subject.vue'
import visitor_evalsubjeCtresult from '../view/visitor/evaluation/subjeCtresult.vue'



//管理端
import cindex from '../view/company/index.vue'
import chome from '../view/company/chome.vue'
import Yzcourse from '../view/company/course/YzCourse/YzCourse.vue'
import Selfcourse from '../view/company/course/SelfCourse/SelfCourse.vue'
import Selffile from '../view/company/course/SelfFile/SelfFile.vue'

import system from '../view/company/System/system.vue'
import Enterprise from '../view/company/System/Enterprise.vue'
import section from '../view/company/section.vue'

import task from '../view/company/train/Task/Task.vue'
import task_subject from '../view/company/train/task_subject.vue'
import taskAdd from '../view/company/train/Task/TaskAdd.vue'
import tclass from '../view/company/train/TClass.vue'
import resources from '../view/company/train/ResourcesPack/Resources.vue'
import entry from '../view/company/train/Entry/Entry.vue'
import entryadd from '../view/company/train/Entry/EntryAdd.vue'
import offline from '../view/company/train/Offline/Offline.vue'
import offlineadd from '../view/company/train/Offline/OfflineAdd.vue'

import censustrain from '../view/company/census/train/train.vue'
import study from '../view/company/census/study/study.vue'
import operation from '../view/company/census/operation/operation.vue'
import time from '../view/company/census/time/time.vue'

import eva_list from '../view/company/evaluate/test_paper/list.vue'
import test_assembly from '../view/company/evaluate/test_paper/test_assembly.vue'
import test_assembly_edit from '../view/company/evaluate/test_paper/test_assembly_edit.vue'
import release from '../view/company/evaluate/test_paper/release.vue'
import eva_test_paper from '../view/company/evaluate/test_paper/test_paper.vue'
import checher_list from '../view/company/evaluate/checher/list.vue'
import test_distribute_list from '../view/company/evaluate/test_distribute_info/list.vue'
import test_distribute_subjeCtresult from '../view/company/evaluate/test_distribute_info/subjeCtresult.vue'
import eva_statistics_list from '../view/company/evaluate/statistics/list.vue'


import quest_list from '../view/company/questionnaire/quest_list/list.vue'//问卷调查--组卷的列表展示
import quest_add from '../view/company/questionnaire/quest_list/add.vue'//问卷调查--组卷的列表展示
import quest_preview from '../view/company/questionnaire/quest_list/preview.vue'//问卷调查--预览
import quest_release from '../view/company/questionnaire/quest_list/release.vue'//问卷调查--发布
import quest_data_list from '../view/company/questionnaire/quest_data/list.vue'//问卷调查--数据列表
import quest_data_details from '../view/company/questionnaire/quest_data/details.vue'//问卷调查--详情
import quest_data_see from '../view/company/questionnaire/quest_data/see.vue'//问卷调查--详情

import company_consult from '../view/company/consult/consult.vue'

import companyee_insert from '../view/share/companyee_insert.vue'
import needs from '../view/share/other/needs.vue'

import share_consult from '../view/share/consult_teacher/consult.vue'
import share_consult_info from '../view/share/consult_teacher/consult_info.vue'



import lost_page from '../components/lost_page.vue'


const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect:'/login'
    },
    {
      path: '/login', name: 'login', component: Login ,
      meta:{
        title:'登录',
        requireAuth:false
      },
    },
    {
       path: '/infobinding', name: 'infobinding', component: infoBinding ,
       meta:{
         title:'信息绑定',
         requireAuth:false,
         type:'0'
       },
     },
    {
      path: '/yzcode', name: 'yzcode', component: YZcode ,
      meta:{
        title:'手机号邮箱登录',
        requireAuth:false
      },
    },
    {
      path: '/findpwd', name: 'findpwd', component: Findpwd ,
      meta:{
        title:'找回密码',
        requireAuth:false
      },
    },
    {
      path: '/home', name: 'home', component: Home ,
      meta:{
        title:'首页',
        requireAuth:true,
        type:'0'
      },
    },

    {
      path: '/visitor_Home', name: 'visitor_Home', component: visitor_Home ,
      meta:{
        title:'首页',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/tasklist', name: 'tasklist', component: Tasklist ,
      meta:{
        title:'任务中心',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_tasklist', name: 'visitor_tasklist', component: visitor_Tasklist ,
      meta:{
        title:'任务中心',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/evaluationlist', name: 'evaluationlist', component: evaluationlist ,
        meta:{
          title:'测评-试卷列表',
          requireAuth:true,
          type:'0'
        },
    },

    {
      path: '/evalsubject', name: 'evalsubject', component: evalsubject ,
        meta:{
          title:'测评-试卷',
          requireAuth:true,
          type:'0'
        },
    },
    {
      path: '/evalsubjeCtresult', name: 'evalsubjeCtresult', component: evalsubjeCtresult ,
        meta:{
          title:'测评-试卷查看',
          requireAuth:true,
          type:'0'
        },
    },
    {
      path: '/moderator', name: 'moderator', component: moderator ,
        meta:{
          title:'版主反馈表',
          requireAuth:true,
          type:'0'
        },
    },
    {
      path: '/visitor_evaluationlist', name: 'visitor_evaluationlist', component: visitor_evaluationlist ,
        meta:{
          title:'测评-试卷列表',
          requireAuth:false,
          type:'0'
        },
    },

    {
      path: '/visitor_evalsubject', name: 'visitor_evalsubject', component: visitor_evalsubject ,
        meta:{
          title:'测评-试卷',
          requireAuth:false,
          type:'0'
        },
    },
    {
      path: '/visitor_evalsubjeCtresult', name: 'visitor_evalsubjeCtresult', component: visitor_evalsubjeCtresult ,
        meta:{
          title:'测评-试卷查看',
          requireAuth:false,
          type:'0'
        },
    },
    {
      path: '/opencourses', name: 'opencourses', component: Opencourses ,
      meta:{
        title:'学习资源',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/Opencourses_tow', name: 'Opencourses_tow', component: Opencourses_tow ,
      meta:{
        title:'学习资源',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/video_info', name: 'video_info', component: video_info,
      meta:{
        title:'课程详情',
        requireAuth:true,
        type:'0'
      },
    },
    // {
    //   path: '/Knowledge', name: 'Knowledge', component: Knowledge ,
    //   meta:{
    //     title:'知识点',
    //     requireAuth:true,
    //     type:'0'
    //   },
    // },
    {
      path: '/visitor_opencourses', name: 'visitor_opencourses', component: visitor_Opencourses ,
      meta:{
        title:'学习资源',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/visitor_Opencourses_tow', name: 'visitor_Opencourses_tow', component: visitor_Opencourses_tow,
      meta:{
        title:'学习资源',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/coursemap', name: 'coursemap', component: coursemap ,
      meta:{
        title:'课程地图',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_coursemap', name: 'visitor_coursemap', component: visitor_coursemap ,
      meta:{
        title:'课程地图',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/courseplay', name: 'courseplay', component: CoursePlay ,
      meta:{
        title:'视频观看',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_courseplay', name: 'visitor_courseplay', component: visitor_CoursePlay ,
      meta:{
        title:'视频观看',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/video_file', name: 'video_file', component: video_file ,
      meta:{
        title:'视频文档阅读',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_video_file', name: 'visitor_video_file', component: visitor_video_file ,
      meta:{
        title:'视频文档阅读',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/visitor_video_file', name: 'visitor_video_file', component: visitor_video_file ,
      meta:{
        title:'视频文档阅读',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/customizedcourses', name: 'customizedcourses', component: Customizedcourses ,
      meta:{
        title:'定制课程',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_customizedcourses', name: 'visitor_customizedcourses', component: visitor_Customizedcourses ,
      meta:{
        title:'定制课程',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/question', name: 'question', component: Question ,
      meta:{
        title:'答疑',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_question', name: 'visitor_question', component: visitor_Question ,
      meta:{
        title:'答疑',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/file', name: 'file', component: File ,
      meta:{
        title:'文档资源',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_file', name: 'visitor_file', component: visitor_File ,
      meta:{
        title:'文档资源',
        requireAuth:false,
        type:'0'
      },
    },
    {
        path: '/Filetow', name: 'Filetow', component: Filetow ,
        meta:{
          title:'文档资源',
          requireAuth:true,
          type:'0'
        },
      },
      {
          path: '/visitor_Filetow', name: 'visitor_Filetow', component: visitor_Filetow ,
          meta:{
            title:'文档资源',
            requireAuth:false,
            type:'0'
          },
        },
    {
      path: '/fileQCregister', name: 'fileQCregister', component: FileQCregister ,
      meta:{
        title:'文档观看',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_fileQCregister', name: 'visitor_fileQCregister', component: visitor_FileQCregister ,
      meta:{
        title:'文档观看',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/file_video', name: 'file_video', component: file_video ,
      meta:{
        title:'文档资源视频讲解',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_file_video', name: 'visitor_file_video', component: visitor_file_video ,
      meta:{
        title:'文档资源视频讲解',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/livebroadcast', name: 'livebroadcast', component: Livebroadcast ,
      meta:{
        title:'药知直播',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_livebroadcast', name: 'visitor_livebroadcast', component:visitor_Livebroadcast ,
      meta:{
        title:'药知直播',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/Liveintroduce', name: 'Liveintroduce', component: Liveintroduce ,
      meta:{
        title:'直播详情',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_Liveintroduce', name: 'visitor_Liveintroduce', component: visitor_Liveintroduce ,
      meta:{
        title:'直播详情',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/Livebroadcasting', name: 'Livebroadcasting', component: Livebroadcasting ,
      meta:{
        title:'直播进行',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_Livebroadcasting', name: 'visitor_Livebroadcasting', component: visitor_Livebroadcasting ,
      meta:{
        title:'直播进行',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/consult', name: 'consult', component: consult ,
      meta:{
        title:'咨询列表',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/minenode', name: 'minenode', component: Minenode ,
      meta:{
        title:'我的笔记',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_minenode', name: 'visitor_minenode', component: visitor_Minenode ,
      meta:{
        title:'我的笔记',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/personal', name: 'personal', component: Personal ,
      meta:{
        title:'个人中心',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_personal', name: 'visitor_personal', component: visitor_Personal ,
      meta:{
        title:'个人中心',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/minenodedetail', name: 'minenodedetail', component: Minenodedetail ,
      meta:{
        title:'笔记详情',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_minenodedetail', name: 'visitor_minenodedetail', component: visitor_Minenodedetail ,
      meta:{
        title:'笔记详情',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/collect', name: 'collect', component: Collect ,
      meta:{
        title:'我的收藏',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_collect', name: 'visitor_collect', component: visitor_Collect ,
      meta:{
        title:'我的收藏',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/watch', name: 'watch', component: Watch ,
      meta:{
        title:'观看记录',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_watch', name: 'visitor_watch', component: visitor_Watch ,
      meta:{
        title:'观看记录',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/Official_account_list', name: 'Official_account_list', component: Official_account_list ,
      meta:{
        title:'公众号',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_Official_account_list', name: 'visitor_Official_account_list', component: visitor_Official_account_list ,
      meta:{
        title:'公众号',
        requireAuth:false,
        type:'0'
      },
    },

     {
        path: '/statute', name: 'statute', component: statute ,
        meta:{
          title:'法规目录',
          requireAuth:true,
          type:'0'
        },
      },
      {
        path: '/statute_map', name: 'statute_map', component: statute_map ,
        meta:{
          title:'法规地图',
          requireAuth:true,
          type:'0'
        },
      },
      {
        path: '/statute_content', name: 'statute_content', component: statute_content ,
        meta:{
          title:'法规文件',
          requireAuth:true,
          type:'0'
        },
      },
      {
         path: '/visitor_statute', name: 'visitor_statute', component: visitor_statute ,
         meta:{
           title:'法规目录',
           requireAuth:false,
           type:'0'
         },
       },
       {
         path: '/visitor_statute_map', name: 'visitor_statute_map', component: visitor_statute_map ,
         meta:{
           title:'法规地图',
           requireAuth:false,
           type:'0'
         },
       },
       {
         path: '/visitor_statute_content', name: 'visitor_statute_content', component: visitor_statute_content ,
         meta:{
           title:'法规文件',
           requireAuth:false,
           type:'0'
         },
       },


    {
      path: '/liveqa', name: 'liveqa', component: Liveqa ,
      meta:{
        title:'答疑直播',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_liveqa', name: 'visitor_liveqa', component: visitor_Liveqa ,
      meta:{
        title:'答疑直播',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/Taskvideo', name: 'Taskvideo', component:Taskvideo ,
      meta:{
        title:'考试任务',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_Taskvideo', name: 'visitor_Taskvideo', component:visitor_Taskvideo ,
      meta:{
        title:'考试任务',
        requireAuth:false,
        type:'0'
      },
    },

    { path: '/Taskfile', name: 'Taskfile', component:Taskfile ,
      meta:{
        title:'学习任务',
        requireAuth:true,
        type:'0'
      },
    },
    { path: 'visitor_/Taskfile', name: 'visitor_Taskfile', component:visitor_Taskfile ,
      meta:{
        title:'学习任务',
        requireAuth:false,
        type:'0'
      },
    },
    { path: '/pdf', name: 'pdf', component:pdf ,
      meta:{
        title:'pdf任务',
        requireAuth:true,
        type:'0'
      },
    },
    { path: '/visitor_pdf', name: 'visitor_pdf', component:visitor_pdf ,
      meta:{
        title:'pdf任务',
        requireAuth:false,
        type:'0'
      },
    },
    { path: '/video', name: 'video', component:video ,
      meta:{
        title:'video任务',
        requireAuth:true,
        type:'0'
      },
    },
    { path: '/visitor_video', name: 'visitor_video', component:visitor_video ,
      meta:{
        title:'video任务',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/visitor_Tasksubject', name: 'visitor_Tasksubject', component:visitor_Tasksubject ,
      meta:{
        title:'考试页',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/Tasksubject', name: 'Tasksubject', component:Tasksubject ,
      meta:{
        title:'考试页',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/TasksubjeCtresult', name: 'TasksubjeCtresult', component:TasksubjeCtresult ,
      meta:{
        title:'考试结果页',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/visitor_TasksubjeCtresult', name: 'visitor_TasksubjeCtresult', component:visitor_TasksubjeCtresult ,
      meta:{
        title:'考试结果页',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/Taskreview', name: 'Taskreview', component:Taskreview ,
      meta:{
        title:'任务回看',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_Taskreview', name: 'visitor_Taskreview', component:visitor_Taskreview ,
      meta:{
        title:'任务回看',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/TaskQuestionnaire', name: 'TaskQuestionnaire', component:TaskQuestionnaire ,
      meta:{
        title:'问卷调查填写',
        requireAuth:true,
        type:'0'
      },
    },
    {
      path: '/visitor_TaskQuestionnaire', name: 'visitor_TaskQuestionnaire', component:visitor_TaskQuestionnaire ,
      meta:{
        title:'问卷调查填写',
        requireAuth:false,
        type:'0'
      },
    },
    {
      path: '/cindex', name: 'cindex', component: cindex ,
      meta:{
        title:'首页',
        requireAuth:true,
        type:'1'
      },
    },
    {
      path: '/chome', name: 'chome', component: chome ,
      meta:{
        title:'首页',
        requireAuth:true,
        type:'1'
      },
    },
    {
      path: '/yzcourse', name: 'yzcourse', component: Yzcourse ,
      meta:{
        title:'药知资源',
        requireAuth:true,
        type:'1'
      },
    },
    {
      path: '/selfcourse', name: 'selfcourse', component: Selfcourse ,
      meta:{
        title:'内部课程',
        requireAuth:true,
        type:'1'
      },
    },
    {
      path: '/selffile', name: 'selffile', component: Selffile ,
      meta:{
        title:'内部文档',
        requireAuth:true,
        type:'1'
      },
    },

  {
    path: '/task', name: 'task', component: task ,
    meta:{
      title:'培训任务',
      requireAuth:true,
        type:'1'
    },
  },
  {
    path: '/task_subject', name: 'task_subject', component: task_subject ,
    meta:{
      title:'试卷查看',
      requireAuth:true,
        type:'1'
    },
  },
  {
    path: '/taskAdd', name: 'taskAdd', component: taskAdd ,
    meta:{
      title:'培训任务',
      requireAuth:true,
        type:'1'
    },
  },
    {
      path: '/tclass', name: 'tclass', component: tclass ,
      meta:{
        title:'培训分类',
        requireAuth:true,
        type:'2'
      },
    },
 {
      path: '/resources', name: 'resources', component: resources ,
      meta:{
        title:'资源包',
        requireAuth:true,
        type:'2'
      },
    },
    {
      path: '/entryadd', name: 'entryadd', component: entryadd ,
      meta:{
        title:'制定入职任务',
        requireAuth:true,
        type:'1'
      },
    },
    {
      path: '/entry', name: 'entry', component: entry,
      meta:{
        title:'入职任务',
        requireAuth:true,
        type:'1'
      },
    },

    {
      path: '/offline', name: 'offline', component: offline ,
      meta:{
        title:'线下任务',
        requireAuth:true,
        type:'1'
      },
    },
    {
      path: '/offlineadd', name: 'offlineadd', component: offlineadd ,
      meta:{
        title:'制定线下任务',
        requireAuth:true,
        type:'1'
      },
    },
    {
      path: '/TeacherCurriculumList', name: 'TeacherCurriculumList', component: TeacherCurriculumList ,
      meta:{
        title:'讲师资源',
        requireAuth:true,
        type:'1'
      },
    },
    //system
    {
      path: '/system', name: 'system', component: system ,
      meta:{
        title:'系统设置',
        requireAuth:true,
        type:'2'
      },
    },
    {
      path: '/Enterprise', name: 'Enterprise', component: Enterprise ,
      meta:{
        title:'企业设置',
        requireAuth:true,
        type:'2'
      },
    },
    {
      path: '/section', name: 'section', component: section ,
      meta:{
        title:'组织架构',
        requireAuth:true,
        type:'2'
      },
    },
    {
      path: '/censustrain', name: 'censustrain', component: censustrain ,
      meta:{
        title:'任务统计',
        requireAuth:true,
        type:'2'
      },
    },
    {
      path: '/study', name: 'study', component: study ,
      meta:{
        title:'学习统计',
        requireAuth:true,
        type:'2'
      },
    },
    {
      path: '/operation', name: 'operation', component: operation ,
      meta:{
        title:'操作记录',
        requireAuth:true,
        type:'2'
      },
    },
    {
      path: '/time', name: 'time', component: time ,
      meta:{
        title:'时长统计',
        requireAuth:true,
         type:'2'
      },
    },
    {
      path: '/eva_list', name: 'eva_list', component: eva_list ,
      meta:{
        title:'试卷管理详情',
        requireAuth:true,
      },
    },
    {
    path: '/test_assembly', name: 'test_assembly', component: test_assembly ,
      meta:{
        title:'试卷组成',
        requireAuth:true,
        type:'2'
      },
    },
    {
    path: '/test_assembly_edit', name: 'test_assembly_edit', component: test_assembly_edit ,
      meta:{
        title:'试卷编辑',
        requireAuth:true,
        type:'2'
      },
    },
    {
    path: '/release', name: 'release', component: release ,
      meta:{
        title:'试卷分发',
        requireAuth:true,
        type:'2'
      },
    },
    {
    path: '/eva_test_paper', name: 'eva_test_paper', component: eva_test_paper ,
      meta:{
        title:'试卷预览',
        requireAuth:true,
        type:'2'
      },
    },

    {
    path: '/checher_list', name: 'checher_list', component: checher_list ,
      meta:{
        title:'审核列表',
        requireAuth:true,
        type:'2'
      },
    },

    {
    path: '/test_distribute_list', name: 'test_distribute_list', component: test_distribute_list ,
      meta:{
        title:'试卷分发详情',
        requireAuth:true,
        type:'2'
      },
    },

    {
    path: '/test_distribute_subjeCtresult', name: 'test_distribute_subjeCtresult', component: test_distribute_subjeCtresult ,
      meta:{
        title:'试卷查看',
        requireAuth:true,
        type:'2'
      },
    },
    {
    path: '/eva_statistics_list', name: 'eva_statistics_list', component: eva_statistics_list ,
      meta:{
        title:'统计',
        requireAuth:true,
        type:'2'
      },
    },

     {
         path: '/quest_list', name: 'quest_list', component: quest_list ,
          meta:{
            title:'调查问卷组卷列表',
            requireAuth:true,
            type:'2'
          },
        },
        {
         path: '/quest_add', name: 'quest_add', component: quest_add ,
          meta:{
            title:'创建调查问卷',
            requireAuth:true,
            type:'2'
          },
        },
        {
         path: '/quest_preview', name: 'quest_preview', component: quest_preview ,
          meta:{
            title:'调查问卷预览',
            requireAuth:true,
            type:'2'
          },
        },
        {
         path: '/quest_release', name: 'quest_release', component: quest_release ,
          meta:{
            title:'调查问卷发布',
            requireAuth:true,
            type:'2'
          },
        },
        {
         path: '/quest_data_list', name: 'quest_data_list', component: quest_data_list ,
          meta:{
            title:'调查问卷数据列表',
            requireAuth:true,
            type:'2'
          },
        },
        {
         path: '/quest_data_details', name: 'quest_data_details', component: quest_data_details ,
          meta:{
            title:'调查问卷数据详情',
            requireAuth:true,
            type:'2'
          },
        },
        {
         path: '/quest_data_see', name: 'quest_data_see', component: quest_data_see ,
          meta:{
            title:'调查问卷详情',
            requireAuth:true,
            type:'2'
          },
        },
        
        {
         path: '/company_consult', name: 'company_consult', component: company_consult ,
          meta:{
            title:'咨询列表',
            requireAuth:true,
            type:'2'
          },
        },
        


        {
          path: '/companyee_insert', name: 'companyee_insert', component: companyee_insert ,
          meta:{
            title:'信息注册',
            requireAuth:false
          },
        },
        {
          path: '/needs', name: 'needs', component: needs ,
          meta:{
            title:'药知平台问题反馈',
            requireAuth:false
          },
        },
        {
          path: '/client_download', name: 'client_download', component: client_download ,
          meta:{
            title:'客户端下载',
            requireAuth:false
          },
        },

        {
              path: '/share_consult', name: 'share_consult', component: share_consult ,
              meta:{
                title:'一对一问答列表',
                requireAuth:false
              },
            },
            {
              path: '/share_consult_info', name: 'share_consult_info', component: share_consult_info ,
              meta:{
                title:'一对一问答详情',
                requireAuth:false
              },
            },

    {
      path: '/lost_page', name: 'lost_page', component: lost_page ,
      meta:{
        title:'页面走失'
      },
    },

    {
      path: "*",
      redirect: "/lost_page",
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/router.js